import { Button, Icon, RadioButton, Typography } from 'components'
import { TypeComponentsItemsArray } from 'components/dynamicTab/optionsNewComponent'
import { Icons, NewComponentModalProps, TypographyTypes } from 'interfaces'
import React, { useMemo, useState } from 'react'

export const NewComponentModal: React.FC<NewComponentModalProps> = ({
	setOpenModal,
	createNewComponent,
	resourceUpdated = false
}): JSX.Element => {
	const [selectedOption, setSelectedOption] = useState('')

	// TODO: Comment title and tags because they are not used yet

	const listItem = [
		// {
		// 	name: 'Title',
		// 	icon: Icons.title,
		// 	value: 'title'
		// },
		{
			name: 'Custom Text',
			icon: Icons.simpleText,
			value: 'simple_text'
		},
		{
			name: 'Phone',
			icon: Icons.phone,
			value: 'phone'
		},
		{
			name: 'Location',
			icon: Icons.location,
			value: 'location'
		},
		{
			name: 'Link',
			icon: Icons.link,
			value: 'link'
		},
		// {
		// 	name: 'Tags',
		// 	icon: Icons.tags,
		// 	value: 'tags'
		// },
		{
			name: 'Mail',
			icon: Icons.mail,
			value: 'mail'
		},
		{
			name: 'Images or video',
			icon: Icons.addImages,
			value: 'assets'
		},
		{
			name: 'Documents',
			icon: Icons.pdfComponent,
			value: 'documents'
		}
	]

	const handleOpenSlide = (val: string): void => {
		setOpenModal(false)
		const aux = val as TypeComponentsItemsArray
		createNewComponent?.(aux)
	}

	const dataList = useMemo(() => {
		return resourceUpdated
			? listItem
			: listItem.filter(
					item => item.value !== 'assets' && item.value !== 'documents'
			  )
	}, [resourceUpdated])

	return (
		<div className="flex flex-col w-full gap-6 mt-8">
			{dataList.map((item, index) => {
				return (
					<div
						aria-hidden="true"
						className="flex justify-between w-full cursor-pointer"
						key={`modal-item${index}`}
						onClick={() => setSelectedOption(item.value)}
					>
						<div className="flex items-center">
							<Icon
								fillPath
								src={item.icon}
								className="w-7 text-blue-primary mr-4"
							/>
							<Typography
								title={item.name}
								className="text-gray-9"
								fontLeading="15/22"
								type={TypographyTypes.p}
							/>
						</div>
						<RadioButton
							id={item.value}
							name="component-new"
							checked={item.value === selectedOption}
							onChange={() => setSelectedOption(item.value)}
							className="cursor-pointer"
						/>
					</div>
				)
			})}
			<div className="flex justify-between items-center w-full gap-1 mt-8">
				<Button
					label="Cancel"
					onClick={() => setOpenModal(false)}
					color="Gray2"
				/>

				<Button
					label="Add Component"
					disabled={!selectedOption}
					onClick={() => handleOpenSlide(selectedOption)}
				/>
			</div>
		</div>
	)
}
